export default __webpack_public_path__ + "static/media/plot.7603181f.svg";